import dayjs from "dayjs"
import { History } from "../../../../../../../service/dashboard/response"
import { Constants } from "../../../../../../../utils/constants"
import { Item, ObjectGeneric } from "../../../../../../../utils/types/generals"
import { es } from "date-fns/locale"
import { format } from "date-fns"
import { deleteDecimalsWithZero } from "../../../../../../../utils/methods/removeDecimals"

const formatResponse = ({response, values, intervale}:{response: History, values: ObjectGeneric; intervale: string}) => {
    const lastDate = response?.hits?.hits?.[0]?._source
    const updateDate = lastDate?.fecha
        ? `Semana: ${lastDate.semana} - ${format(
            dayjs(lastDate?.fecha).toDate(),
            Constants.humanFormat,
            { locale: es }
        )}`
        : ''
    
    const cuestionarioResultadoMap: {[key: string]: number} = {}
    response?.hits?.hits?.forEach((hit: any) => {
        const source = hit._source
        if (source?.unidad_id && source?.cuestionario_resultado !== undefined) {
            cuestionarioResultadoMap[source.unidad_id] = source.cuestionario_resultado
        }
    })

    const hits =
        (response?.aggregations as any)?.ranking_unidades?.buckets?.map((item: any, index: number) => {
            const unit = values.unit?.find((unitItems: Item) => unitItems.value == item.key)
            const ultimoRegistro = item?.ultimo_registro?.hits?.hits?.[0]?._source

            const totalPreguntas = item?.total_preguntas?.value || 0
            const preguntasContestadas = item?.total_preguntas_contestadas?.value || 0
            const porcentajeAvance = totalPreguntas > 0 
                ? ((preguntasContestadas / totalPreguntas) * 100).toFixed(1)
                : '0.0'

            const totalProgramados = Math.round(item?.total_cuestionarios_programados?.value || 0)
            const enProceso = Math.round(item?.cuestionarios_en_proceso?.doc_count || 0)
            const finalizados = Math.round(item?.cuestionarios_finalizados?.doc_count || 0)

            const porcentajeEnProceso = totalProgramados > 0 
                ? ((enProceso / totalProgramados) * 100).toFixed(1)
                : '0.0'
            const porcentajeFinalizados = totalProgramados > 0 
                ? ((finalizados / totalProgramados) * 100).toFixed(1)
                : '0.0'

            return {
                id: `${item.key} - ${ultimoRegistro?.unidad || unit?.name || ''}`,
                unit: ultimoRegistro?.unidad || unit?.name,
                keyCode: ultimoRegistro?.keyCode || unit?.keyCode,
                semana: ultimoRegistro?.semana || null,
                fecha: ultimoRegistro?.fecha || null,
                programQuestionnaires: totalProgramados,
                percentageAdvanceQuestions: `${porcentajeAvance}% (${preguntasContestadas}/${totalPreguntas})`,
                questionnairesInProcess: `${porcentajeEnProceso}% (${enProceso}/${totalProgramados})`,
                completedQuestionnaires: `${porcentajeFinalizados}% (${finalizados}/${totalProgramados})`,
                resultAverage: item?.promedio_resultados?.value 
                    ? `${deleteDecimalsWithZero(Number(item?.promedio_resultados?.value).toFixed(2))}`
                    : '0',
                avance: item?.promedio_avance?.value || item?.promedio_avance?.value == '0' 
                    ? `${deleteDecimalsWithZero(Number(item?.promedio_avance?.value).toFixed(2))}%` 
                    : null
            }
        }) ?? []

    return { hits, updateDate}
}

export { formatResponse }
